import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../css/Teaching.css';

function Teaching() {
  const { t } = useTranslation();
  const teachingExperience = t('teaching_experience_current', { returnObjects: true });
  const workExperience = t('work_experience_current', { returnObjects: true });

  return (
    <Container>

      <section id="teaching" className="teaching-section teaching-section-teaching">
        <h2>{t('nav_teaching')}</h2>
        <ol>
          {teachingExperience.map((experience, index) => (
            <li key={index}>
              {experience.institution}, {experience.dates}
              {experience.location && `, ${experience.location}`}
            </li>
          ))}
        </ol>
      </section>

      <section id="work" className="work-section teaching-section-work">
        <h2>{t('nav_work')}</h2>
        <ol>
          {workExperience.map((experience, index) => (
            <li key={index}>
              {experience.institution}, {experience.dates}
              {experience.location && `, ${experience.location}`}
            </li>
          ))}
        </ol>
      </section>
    </Container>
  );
}

export default Teaching;
